import { inject, Injectable, signal } from '@angular/core';

import { EMPTY, catchError } from 'rxjs';

import { LocalStorageService } from '@core/common-legacy';
import { TellentHttpApiService } from '@core/tellent-http-legacy';

import { HELP_DROPDOWN_CONFIG } from './help-dropdown.config';

interface ProductUpdatesResponse {
  data: Array<{ publishedAt: string }>;
}

@Injectable()
export class HelpDropdownService {
  readonly #http = inject(TellentHttpApiService);
  readonly #localStorage = inject(LocalStorageService);
  readonly #config = inject(HELP_DROPDOWN_CONFIG);

  public readonly hasUnreadUpdates = signal(false);

  #latestPublishedAt: string | null = null;

  constructor() {
    this.#checkForUpdates();
  }

  public markAsSeen(): void {
    if (this.#latestPublishedAt) {
      this.#localStorage.set(this.#storageKey, this.#latestPublishedAt);
      this.hasUnreadUpdates.set(false);
    }
  }

  get #storageKey(): string {
    return `HelpDropdown#${this.#config.userId}_lastSeenProductUpdate`;
  }

  #checkForUpdates(): void {
    this.#http
      .get<ProductUpdatesResponse>(
        '/product-updates',
        { page: '1', pageSize: '1' },
        { skipCompany: true },
      )
      .pipe(catchError(() => EMPTY))
      .subscribe(response => {
        const latest = response.data[0];
        if (!latest) return;

        this.#latestPublishedAt = latest.publishedAt;
        const lastSeen = this.#localStorage.get(this.#storageKey);
        this.hasUnreadUpdates.set(latest.publishedAt !== lastSeen);
      });
  }
}
